import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { camelizeKeys } from "humps";

export function loadGlobalRights() {
  return async (dispatch, getState) => {
    let loaded = false;
    let loading = false;
    let globalRights = getState().globalRights;

    if (globalRights) {
      loaded = globalRights.loaded;
      loading = globalRights.loading;
    }

    if (loaded || loading) return;

    try {
      dispatch({ type: actionTypes.LOAD_GLOBAL_RIGHTS_STARTED });
      const response = await dispatch(sendHttpRequest(api.loadGlobalRights()));

      const result = response.globalRights.reduce(
        (prev, right) => ({
          ...prev,
          [right.code.toLowerCase()]: right.hasRight
        }),
        {}
      );

      const camelizedJson = camelizeKeys(result);

      dispatch({ type: actionTypes.LOAD_GLOBAL_RIGHTS_SUCCESS, payload: camelizedJson });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
